<template>
  <section class="quick-quote-info">
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Studying Country</span>
        <span>{{getAllOptionName25('study_country',quoteForm.country_id)}}</span>
      </div>
      <div class="tr">
        <span>Student Age</span>
        <span>{{quoteForm.student_age}}</span>
      </div>

    </div>
    <div class="table">
      <div class="tr th">
        <span>Item</span>
        <span>Information</span>
      </div>
      <div class="tr">
        <span>Studying Full-time</span>
        <span>{{ getOptionName('yesNoOptions', quoteForm.is_full_time) }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'StudentQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>
.quick-quote-info {
    display: flex;
    justify-content: space-between;
    .table {
        width: calc(50% - 10px);
    }
}
</style>
